// For new features, use sectorsApi slice. In the future we might deprecate this reducer.

import { fromJS } from 'immutable';
import * as reduxHelper from 'store/utils/reduxHelper';
import Sector from 'models/Sector';
import types from './types';

export const initialState = fromJS({
  ...reduxHelper.applyReceiveInfo({
    data: [],
    errorMessage: '',
  }),
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case types.SECTORS_FETCH:
      return state.merge(reduxHelper.applyRequestInfo());
    case types.SECTORS_FETCH_SUCCEEDED:
      return state.merge(
        reduxHelper.applyReceiveInfo({
          data: action.payload.map(sector => new Sector(sector)),
        })
      );
    case types.SECTORS_FETCH_FAILED:
      return state.merge(
        reduxHelper.applyErrorInfo({
          errorMessage: action.payload,
        })
      );
    default:
      return state;
  }
}
